export default "__VITE_ASSET__B9pINT1a__"